
import apiRequest from "./apiRequest";

export const Mbp2RegisterApi = {

    fetchMbp2Register: (accountId, token) => {
    return apiRequest(`/api/register/mbp-2?accountId=${accountId}`, 'GET', token);
  },
  

  // Submit MGT-1 form data
  submitMbp2Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/mbp-2?accountId=${accountId}`, 'POST', token, formData);
  },

      addNewRegisterOfSecurity: (id, payload, token) => {
      return apiRequest(
        `/api/register/mbp-2/add-new/register-of-security/${id}`,
        "POST",
        token,
        payload          // ← body is forwarded as-is to apiRequest
      );
    },

 

  
};